export interface ICredentials {
  id_person?: string;
  id_user?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  verified?: boolean;
  great_investor_status?: string;
  authorities?: string[];
  social_user?: boolean;
  has_dni?: boolean;
}

export class Credentials implements ICredentials {
  constructor(
    public id_person?: string,
    public id_user?: string,
    public email?: string,
    public first_name?: string,
    public last_name?: string,
    public phone?: string,
    public verified?: boolean,
    public great_investor_status?: string,
    public authorities?: string[],
    public social_user?: boolean,
    public has_dni?: boolean
  ) {}
}
